import * as React from 'react';
import Select from 'react-select';
import { IObservableObject, observable } from 'mobx';
import { EmployeeDto } from '../../pages/user/userTypes';
import { observer } from 'mobx-react';
import { getEmployees } from '../../pages/user/userApi';
import { Chip } from '@material-ui/core';
import { Cancel as CancelIcon } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import { translation } from '../../i18n';
import { SelectedAppraisers } from '../../pages/questionnaire/QuestionnaireForm';
import { MenuItem } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { TextField } from '@material-ui/core';

interface Props {
  selectedEmployees: SelectedAppraisers & IObservableObject
}

function MultiValue(props: any) {
  return (
    <Chip
      style={{margin: `2px 1px`,}}
      tabIndex={-1}
      label={props.children}
      key={props.data.value.id}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function NoOptionsMessage(props: any) {
  return (
    <Typography
      color="textSecondary"
      style={{
        padding: `4px 8px`,
      }}
      {...props.innerProps}
    >
      {translation.t('employeeMultiSelect.noOptions')}
    </Typography>
  );
}

// @ts-ignore
function inputComponent({ inputRef, ...props }) {
  return <div   style={{
    display: 'flex',
    padding: 0,
  }} ref={inputRef} {...props} />;
}

function Control(props: any) {
  return (
    <TextField
      label={translation.t('employeeMultiSelect.label')}
      required={true}
      style={{marginTop: 8, marginBottom: 4}}
      InputLabelProps={{shrink: true,}}
      fullWidth={true}
      InputProps={{
        inputComponent,
        inputProps: {
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Menu(props:any) {
  return (
    <Paper square={true} style={{
      position: 'absolute',
      zIndex: 1,
      marginTop: 4,
      left: 0,
      right: 0,
    }} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

function Option(props: any) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

const component = {
  MultiValue,
  NoOptionsMessage,
  Control,
  Menu,
  Option
};

@observer
class EmployeeMultiSelect extends React.Component<Props> {
  public state = {
    single: null,
    multi: null,
  };

  @observable private employees: EmployeeDto[] = [];

  constructor(props: Props) {
    super(props)
  }

  public componentDidMount(): void {
    if (this.props.selectedEmployees.appraisers) {
      const currentEmployees = this.props.selectedEmployees.appraisers;
      const employees: any = [];

      currentEmployees.map( employee => {
        employees.push(
          {
            value: employee.id,
            label: employee.firstName + ' ' + employee.lastName,
            selectedEmployee: employee,
          }
        )
      });

      this.setState({
        'single': employees
      })
    }
    this.loadEmployees();
  }

  public render() {
    const {single} = this.state;

    return (
      <Select
        value={single}
        onChange={this.handleChange('single')}
        options={this.toOption()}
        isSearchable={true}
        isMulti={true}
        components={component}
        placeholder={translation.t('employeeMultiSelect.placeholder')}
      />
    );
  }

  private handleChange = (name: string) => (value: any) => {
    this.props.selectedEmployees.appraisers = [];
    value.map((it: any) => this.props.selectedEmployees.appraisers.push(it.selectedEmployee));
    this.setState({
      [name]: value,
    });
  };

  private loadEmployees = () => {
    getEmployees({searchText: ''}, {page: 0, size: 1000000,}).then(page => {
      this.employees = page.content;

    });
  };

  private toOption = () => {
    return this.employees.map(
      (employee: EmployeeDto) => ({
        value: employee.id,
        label: employee.firstName + ' ' + employee.lastName,
        selectedEmployee: employee,
      })
    )
  }

}

export default EmployeeMultiSelect;
